import Vue from 'www/vue_components'
import vuetify from 'www/modules/vuetify-plugin'
import BaseDialog from './BaseDialog.vue'

const mountElement = document.querySelector('.base-dialog')

if (mountElement) {
  new Vue({
    vuetify,
    el: mountElement,
    name: 'BaseDialogRoot',
    components: {
      BaseDialog,
    },
  })
}
